import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    padding: theme.spacing(2, 5),
    backgroundColor: theme.palette.text.white,
    boxShadow: `0px -1px 0px 0px ${theme.palette.labraV2BoxShadow.dark} inset`,
    position: 'sticky',
    zIndex: 99,
    top: 0,
  },
  appTitleHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 'fit-content',
  },
  appBackIcon: {
    display: 'flex',
    margin: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  appTitleHeadingText: {
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '36px',
    color: theme.palette.labraText.primary,
  },
  root: {
    padding: theme.spacing(4, 5),
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    gap: theme.spacing(3),
  },
  stickyStatusListing: {
    top: theme.spacing(10.5),
    zIndex: 1,
  },
  statusWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    background: theme.palette.text.white,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3, 4),
  },
}))
